// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + ({"443":"about","535":"login"}[chunkId] || chunkId) + "." + {"195":"135cd999","443":"9d727926","535":"b4cfd974"}[chunkId] + ".js";
};